import { ChangeDetectorRef, Directive, EmbeddedViewRef, inject, TemplateRef, ViewContainerRef } from "@angular/core";
import { UserStore } from "@dcc/vestas-online/data-access";
import { filter } from "rxjs/operators";
import { takeUntilDestroyed, toObservable } from "@angular/core/rxjs-interop";

@Directive({
    standalone: true,
    selector: "[voIsAdmin]"
})
export class AdminDirective {
    private store = inject(UserStore);
    private _vcr = inject(ViewContainerRef);
    private _tpl = inject<TemplateRef<unknown>>(TemplateRef);
    private _cdr = inject(ChangeDetectorRef);

    private _userIsAdmin = false;

    private readonly _thenTemplateRef: TemplateRef<unknown>;
    private _thenViewRef: EmbeddedViewRef<unknown> | null | undefined;

    constructor() {
        this._thenTemplateRef = this._tpl;

        toObservable(this.store.isAdmin)
            .pipe(
                takeUntilDestroyed(),
                filter((val) => !!val)
            )
            .subscribe((isAdmin: boolean | null) => {
                this._userIsAdmin = isAdmin as boolean;
                this._cdr.markForCheck();
                this._updateView();
            });
    }

    private _updateView() {
        if (this._userIsAdmin) {
            if (this._thenTemplateRef) {
                this._vcr.clear();
                this._thenViewRef = this._vcr.createEmbeddedView(this._thenTemplateRef);
            }
        } else {
            this._vcr.clear();
            this._thenViewRef = null;
        }
    }
}
